/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Tag_Filters_LabelInputs */

const en_editor_tag_filters_label = /** @type {(inputs: Editor_Tag_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag filters`)
};

const fr_editor_tag_filters_label = /** @type {(inputs: Editor_Tag_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtres d'etiquettes`)
};

const de_editor_tag_filters_label = /** @type {(inputs: Editor_Tag_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag-Filter`)
};

const it_editor_tag_filters_label = /** @type {(inputs: Editor_Tag_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtri per tag`)
};

const ru_editor_tag_filters_label = /** @type {(inputs: Editor_Tag_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фильтры тегов`)
};

const es_editor_tag_filters_label = /** @type {(inputs: Editor_Tag_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros de etiquetas`)
};

const zh_cn2_editor_tag_filters_label = /** @type {(inputs: Editor_Tag_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标签筛选器`)
};

const ja_editor_tag_filters_label = /** @type {(inputs: Editor_Tag_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグフィルター`)
};

const hi_editor_tag_filters_label = /** @type {(inputs: Editor_Tag_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टैग फ़िल्टर`)
};

const pt_pt2_editor_tag_filters_label = /** @type {(inputs: Editor_Tag_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros de tags`)
};

/**
* | output |
* | --- |
* | "Tag filters" |
*
* @param {Editor_Tag_Filters_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_tag_filters_label = /** @type {((inputs?: Editor_Tag_Filters_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Tag_Filters_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_tag_filters_label(inputs)
	if (locale === "de") return de_editor_tag_filters_label(inputs)
	if (locale === "it") return it_editor_tag_filters_label(inputs)
	if (locale === "ru") return ru_editor_tag_filters_label(inputs)
	if (locale === "es") return es_editor_tag_filters_label(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_tag_filters_label(inputs)
	if (locale === "ja") return ja_editor_tag_filters_label(inputs)
	if (locale === "hi") return hi_editor_tag_filters_label(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_tag_filters_label(inputs)
	return en_editor_tag_filters_label(inputs)
});